module.exports = __webpack_public_path__ + "img/fa-regular-400.361dbb1.svg";